// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#idea-home{margin-left:0}.image-uploader{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;height:38px;margin:auto;vertical-align:middle;text-align:center}.image-uploader:hover{border-color:#409eff}.el-upload{line-height:38px;width:100%}.image{height:38px}", ""]);
// Exports
module.exports = exports;
